import React from "react";
import Link from "next/link";
import { BiPhone, BiEnvelope, BiLogoLinkedin } from "react-icons/bi";
import { useTranslations } from "../../../locales/useTranslations";

const PowerBiCTA = () => {
    const { t } = useTranslations();
    return (
        <>
            <div className="service-details ptb-70">
                <div className="container">
                    <div className="service-details-content">

                        <div>
                            <h2>{t('powerBi_cta_title')}</h2>
                            <p>
                                {t('powerBi_cta_description')}
                            </p>
                        </div>

                        <div className="pt-35">
                            <h3>{t('powerBi_cta_title2')}</h3>
                            <p>
                                {t('powerBi_cta_description2')}
                            </p>
                        </div>

                        <div className="service-details pt-35">
                            <div className="service-details-info ">
                                <div className="large-info-box">
                                    <h4>{t('powerBi_cta_title3')}</h4>
                                    <span>{t('powerBi_cta_description3')}</span>
                                </div>

                                <div className="single-info-box">
                                    <h4>{t('powerBi_cta_title4')}</h4>
                                    <ul className="social">
                                        <li>
                                            <a href="tel://+4943170577024" target="_blank">
                                                <BiPhone />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="mailto:info@simplify-data.de" target="_blank">
                                                <BiEnvelope />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank">
                                                <BiLogoLinkedin />
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="single-info-box">
                                    <Link href="/kontakt/" className="default-btn">
                                        {t('powerBi_cta_button')}
                                    </Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default PowerBiCTA;
